import { useCallback, useRef } from 'react';

/*
    Navegacion visual para editores inline del modulo de correos.

    Los formularios siguen viviendo dentro de la misma vista (igual que el
    resto del admin), pero al abrir un alta/edicion llevamos el viewport al
    editor y enfocamos el primer control util sin provocar un segundo salto.
*/
export const useEmailEditorNavigation = () => {
    const editorRef = useRef(null);

    const goToEditor = useCallback(() => {
        window.setTimeout(() => {
            const EDITOR = editorRef.current;
            if (!EDITOR) return;

            EDITOR.scrollIntoView({ behavior: 'smooth', block: 'start' });

            window.setTimeout(() => {
                const CONTROL = EDITOR.querySelector(
                    'input:not([type="hidden"]):not([type="file"]):not([type="checkbox"]):not([disabled]), textarea:not([disabled]), [role="combobox"]'
                );

                CONTROL?.focus?.({ preventScroll: true });
            }, 360);
        }, 70);
    }, []);

    return { editorRef, goToEditor };
};
